// extracted by mini-css-extract-plugin
export default {"tagsHolder":"HotelTags_tagsHolder__hT8+s","tag":"HotelTags_tag__NJdqv","noTags":"HotelTags_noTags__5d-VG"};